import Api from '../Base'

class GetCategoryById extends Api {
  requestUrl = `/api/category/${this.getParams().id}`
}

export default GetCategoryById
